import { createSelector } from 'reselect';
// import _get from 'lodash/get';

export const getCurrentGoodId = state => state.freeSauces.goodId;
export const getFreeSauces = state => state.freeSauces;
// export const getCartItems = state => state.cart.composition;

// export const addedSaucesSelector = createSelector([getCartItems, getCurrentGoodId], (items, id) => {
//   const goodInCart = items.find(good => good.item.id === id) || {};
//   return _get(goodInCart, 'item.added_sauces', []);
// });

export const avaivableCountSelector = createSelector(
  [getFreeSauces],
  ({ freeCount, freeAddedCount }) => {
    return freeCount - freeAddedCount;
  },
);
